var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://manage.fankeymice.com/logo.png"},on:{"click":_vm.toGit}})
}
var staticRenderFns = []

export { render, staticRenderFns }